import React from 'react'; 
import WithConsumer from '../../context/WithConsumer';
import ProjectHeader from './ProjectHeader';
import ProjectDescription from './ProjectDescription';
import ProjectSingleImage from './ProjectSingleImage';
import ProjectDoubleImages from './ProjectDoubleImages';
import ProjectToTop from './ProjectToTop';
import ProjectEnquiry from './ProjectEnquiry';
import Footer from '../global/Footer';
import { Link } from 'react-router-dom';

const Project = ({ context }) => {

	let results = '';
		 
    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
    
    const ctxDoRender = () => context.doRender;
    const doRender = ctxDoRender();
       
    if (post && doRender) {
	    
	    console.log(post);
	    	    
	    let pageClass = 'c-page c-page-' + post.slug + ' c-project';
		
		if (pageLoaded) {
		    pageClass = pageClass + ' state-page-loaded';
	    }
	    
    	if (post.blocks) {
						
			if (context.appError){
			
				return null; 
			
			} else {
				
				return (
					<>	
						<div className={pageClass}>
														
							<ProjectHeader post={post} />
							
							<ProjectDescription post={post} />
							
							{post.blocks.map((block,i) =>
								{
									if (block.src) {
										return (
											<ProjectSingleImage block={block} />
										)
									} else {
										return (
											<ProjectDoubleImages block={block} />
										)
									}
								}
							)}
							
							{post.enquiry_form_id &&
							
								<ProjectEnquiry post={post} />
							
							}
							
							{!post.enquiry_form_id &&
							
								<ProjectToTop />
							
							}
							
							<Footer post={post} />
																						
						</div>
						
					</>
				)
					
			}
		} else {
			return null;
		}
	} else {
		return null;
	}
};
export default WithConsumer(Project);